import { isNullType } from './is-null-type';

export const isNumberBlank = (x) => isNullType(x) || isNaN(Number(x));
